import { gql } from "@apollo/client";

export const saveAnswer = gql`
mutation SaveHealthQuestionnaireAnswers($id: String!, $input: SaveHealthQuestionnaireAnswersInput!) {
  saveHealthQuestionnaireAnswers(id: $id, input: $input)
}
`;